import { render } from "./KryptonPopinHeaderWrapper.vue?vue&type=template&id=7125abfb&lang=pug"
import script from "./KryptonPopinHeaderWrapper.vue?vue&type=script&lang=js"
export * from "./KryptonPopinHeaderWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__